import React, { useRef } from 'react';
import FaqContent from './FaqContent';
import { CardTitle, DiscrepancyText } from './styles';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import { internalURLs } from 'src/components/config/internal-link';
import useModifiedUrl from 'src/hooks/useModifiedUrl';

const FAQs: React.FC = () => {
  const getText = useTranslationHelper();
  const faqRef = useRef<HTMLDivElement>(null);
  const overviewFinalPath = useModifiedUrl(internalURLs.PrinterOverviewURL);
  return (
    <>
      <CardTitle>{getText('faq.title', 'FAQs')}</CardTitle>
      <FaqContent faqRef={faqRef} />
      <DiscrepancyText>
        <sup>1</sup>
        {getText(
          'discrepancy-text.footer-content1',
          'HP All-In Plan for Print includes select printers and services paid for with a monthly fee charged to your credit or your debit card. HP owns the printer, printer cartridges and ink bottles throughout the subscription, and they must be returned to HP upon printer upgrade or cancellation. For complete details see '
        )}
        <a
          href="https://www.hp.com/us-en/all-in-plan/terms.html"
          target="_blank"
          rel="noreferrer"
        >
          {getText(
            'discrepancy-text.footer-link1',
            'HP All-In Plan Terms of Service'
          )}
        </a>
        {getText(
          'discrepancy-text.footer-content2',
          '. Your Plan and monthly payments, plus any applicable taxes, will automatically renew and continue unless you cancel. Your payment amount is determined by the Plan you select. If you cancel your Plan within 30 days of enrolling and return the printer within 10 days of cancellation, you will not owe anything. Any charge made to your payment method will be fully refunded. You will be emailed a prepaid return label for the Printer, and cartridge(s) and ink bottles. You may modify your services or cancel your Plan at any time by visiting '
        )}
        <a
          href={overviewFinalPath}
          target="_blank"
          rel="noreferrer"
        >
          {getText('discrepancy-text.footer-link2', 'MyAccount')}
        </a>
        {getText(
          'discrepancy-text.footer-content3',
          ' and clicking Cancel or by calling 1-888-447-0148. Early cancellation fees will apply if you cancel after the first 30 days and during the first and second year of your Plan based on the printer you select. After the 24-month term (for ink cartridge printers) and after 36 months (for HP Smart Tank printers), you may cancel anytime without a cancellation fee. Individual print services cannot be cancelled independent of canceling the All-In Plan for Print except for paper which may be modified or cancelled independently. After the 24 or 36 month term, you may continue your plan with your original printer by continuing to pay the monthly fee. You are also eligible to upgrade your printer after the 24 or 36 month term. If and when you upgrade, your monthly fee may change based on printer model and current prices, and the cancellation fee cycle starts anew, with the cancellation.'
        )}
      </DiscrepancyText>
    </>
  );
};

export default FAQs;
